

export default function FormTitle({text}){
    return (
        <div className="row justify-content-center align-items-center" style={{ paddingTop: "25px", paddingBottom: "25px"}}>
            <h4 className="site-title">{text}</h4>
        </div>
    )
}